import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import PhoneNumber from "./Components/Input/PhoneNumber";
import OtpInput from "react-otp-input";
import auth from "./Account/Auth";
import be from "./BE";

function WhatsappLogin({ setLoggingProvider, redirect, callback }) {
  /* stages:
   * start: show "login via whatsapp" button
   * phone: ask the user to enter their phone number and country prefix
   * otp: shows the otp modal
   */
  const [stage, setStage] = useState("start");
  const [country, setCountry] = useState("");
  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [sendingNumber, setSendingNumber] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);

  const sendNumber = async () => {
    setSendingNumber(true);
    try {
      await be
        .post(
          "account-jubilant",
          "/account/whatsapp/otp",
          { phoneNumber: number, dialingCode: country?.dial },
          false,
          true
        )
        .then(() => {
          setStage("otp");
        })
        .catch((error) => {
          console.log(
            "[whatsapp login] network error while sending user number to be:",
            error
          );
        });
    } catch (error) {
      console.error(
        "[whatsapp login] functional error while sending user numebr to be:",
        error
      );
    } finally {
      setSendingNumber(false);
    }
  };

  const sendOtp = async () => {
    try {
      setLoggingProvider && setLoggingProvider("whatsapp");
      setSendingOtp(true);
      setError("");
      await auth
        .login(
          { phoneNumber: number, dialingCode: country?.dial, otp: otp },
          "/account/login/whatsapp"
        )
        .then(() => {
          // check on '/onboarding' pathname helps avoiding redirect override
          // in case auth module needs to bring the user on onboarding page
          if (redirect && window.location.pathname !== "/onboarding") {
            window.location.href = redirect;
          }
          if (callback) {
            callback();
          }
        })
        .catch((e) => {
          console.log(
            "request catch: error while logging in with whatsapp provider: ",
            e
          );
          setError(e);
        });
    } catch (e) {
      console.log(
        "functional catch: error while logging in with whatsapp provider: ",
        e
      );
    } finally {
      setSendingOtp(false);
      setLoggingProvider && setLoggingProvider("none");
    }
  };

  return (
    <div className="tw-max-w-[400px] tw-justify-center tw-flex ">
      {stage === "start" && (
        <div>
          <Button
            onClick={() => {
              setStage("phone");
              setLoggingProvider("whatsapp");
            }}
            style={{
              height: 40,
              background: "#374151",
              border: "none",
              minWidth: 350,
            }}
            className="tw-rounded"
          >
            <i className="tw-text-green-500 tw-mr-2 fa-brands fa-whatsapp"></i>
            Sign in with Whatsapp
          </Button>
        </div>
      )}
      {stage === "phone" && (
        <div className="tw-gap-2 tw-flex tw-flex-col">
          <div>Sign in with Whatsapp: Add your phone number</div>
          <PhoneNumber
            selectedCountry={country}
            onSelectCountry={setCountry}
            number={number}
            onChangeNumber={setNumber}
            disabled={sendingNumber}
            required
          />
          <Button
            onClick={() => sendNumber()}
            variant="primary"
            disabled={sendingNumber}
            style={{
              height: 40,
              background: "#374151",
              border: "none",
              minWidth: 80,
            }}
            className="tw-rounded"
          >
            {sendingNumber ? (
              <Spinner size="sm" animation="border" variant="light" />
            ) : (
              <>Continue</>
            )}
          </Button>
        </div>
      )}
      {stage === "otp" && (
        <div className="tw-flex tw-gap-4 tw-flex-col">
          <div className="tw-justify-start tw-text-start">
            <span>
              To continue, please enter the 6-digit verification code sent to
              your Whatsapp phone number
            </span>
            <br />
            <span className="tw-font-medium">
              ({country?.dial} {number})
            </span>
          </div>
          <div className="tw-flex tw-justify-center">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={<span></span>}
              renderInput={(props) => <input {...props} />}
              inputStyle={{
                margin: 5,
                padding: "5px 0 5px 0",
                borderRadius: "5px",
                width: 30,
              }}
            />
          </div>
          <div className="tw-flex tw-gap-2 tw-justify-center">
            <Button
              onClick={() => sendOtp()}
              variant="primary"
              type="submit"
              disabled={sendingNumber}
              style={{
                height: 40,
                background: "#374151",
                border: "none",
                minWidth: 80,
              }}
              className="tw-rounded tw-w-full"
            >
              {sendingOtp ? (
                <Spinner size="sm" animation="border" variant="light" />
              ) : (
                <>Continue</>
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default WhatsappLogin;
